import { PerisurgicalActivityPlan as PerisurgicalActivityPlanUI } from 'components/activity-plan/perisurgical/PerisurgicalActivityPlan';
import { useActivityPlan } from 'providers/ActivityPlanProvider';
import React from 'react';
import {
  copyAllExercises,
  copyUniqueExercises
} from 'utils/copyExercisesToClipboard';

export const PerisurgicalActivityPlan = (): JSX.Element | null => {
  const { activityPlan } = useActivityPlan();

  return activityPlan ? (
    <PerisurgicalActivityPlanUI
      activityPlan={activityPlan}
      onCopyAllExercises={copyAllExercises}
      onCopyUniqueExercises={copyUniqueExercises}
    />
  ) : null;
};
